import { Injectable } from '@angular/core';
import { Cart, SavedQuoteTableService } from 'gung-standard';
import { first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarLinerSavedQuoteTableService extends SavedQuoteTableService {
  shouldMailQuotePdf = false;

  public downloadQuotePdf(cart: Cart): void {
    if (cart.extra.mysetup.extra.quotations.showIncludedItems) {
      this.shouldMailQuotePdf = true;
    }
    if (this.shouldMailQuotePdf) {
      this.cartExportService
        .exportSavedQuote(
          cart,
          /* template */ null,
          /* additionalVariables */ null,
          /* additionalParams */ { overrideFilename: cart.name + '.pdf' },
          /* useV2 */ false
        )
        .pipe(first())
        .subscribe();
    } else {
      this.pdfDownloadIndicatorService.setDownloading({ downloading: true, data: null });
      this.cartExportService
        .exportSavedQuoteBytes(cart, cart.name, undefined, undefined, undefined, undefined, this.usePuppeteerEngine)
        .subscribe(x => {
          this.pdfDownloadIndicatorService.setDownloading({ downloading: false, data: null });
        });
    }
  }
}
